import { requestApi } from './Api';

export const getCodes = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/codes/get',
    params
  });

export const getSpecialtyBenefitType = (navigate, params) =>
  requestApi({
    url: '/api/codes/benefit_type_code/get',
    params,
    navigate
  });
